import React, { useState } from "react";
import { toast } from "react-hot-toast";

const INPUT_CLASS = "w-full rounded-md border border-gray-300 p-1.5 text-sm outline-none transition-all focus:border-primary-500 focus:ring-2 focus:ring-primary-500";

const ClinicianFormModal = ({ title, initialValues, submitLabel, onSubmit, onClose, isPending }) => {
  const [firstName, setFirstName] = useState(initialValues?.firstName || "");
  const [lastName, setLastName] = useState(initialValues?.lastName || "");
  const [email, setEmail] = useState(initialValues?.email || "");
  const [phone, setPhone] = useState(initialValues?.phone || "");
  const [code, setCode] = useState(initialValues?.code || "");
  const [birthdate, setBirthdate] = useState(initialValues?.birthdate || "");

  const onSave = () => {
    if (!firstName || !lastName) return toast.error("Le prénom et le nom sont requis");
    onSubmit({ firstName, lastName, email, phone, code, birthdate });
  };

  return (
    <div className="fixed inset-0 z-50 flex h-screen w-screen items-center justify-center bg-black/20">
      <div className="min-w-[500px] max-w-2xl rounded-lg bg-white px-6 py-4">
        <h2 className="mb-4 text-lg font-medium">{title}</h2>
        <div className="mb-4 space-y-4">
          <div className="flex gap-4">
            <div className="flex flex-1 flex-col gap-2">
              <p className="text-sm font-medium">Prénom</p>
              <input autoFocus className={INPUT_CLASS} placeholder="Jean" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
            </div>
            <div className="flex flex-1 flex-col gap-2">
              <p className="text-sm font-medium">Nom</p>
              <input className={INPUT_CLASS} placeholder="Dupont" value={lastName} onChange={(e) => setLastName(e.target.value)} />
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex flex-1 flex-col gap-2">
              <p className="text-sm font-medium">Email</p>
              <input type="email" className={INPUT_CLASS} placeholder="email@exemple.com" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="flex flex-1 flex-col gap-2">
              <p className="text-sm font-medium">Téléphone</p>
              <input type="tel" className={INPUT_CLASS} placeholder="06 12 34 56 78" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </div>
          </div>
          <div className="flex gap-4">
            <div className="flex flex-1 flex-col gap-2">
              <p className="text-sm font-medium">Code préleveur</p>
              <input className={INPUT_CLASS} placeholder="CODE" value={code} onChange={(e) => setCode(e.target.value)} />
            </div>
            <div className="flex flex-1 flex-col gap-2">
              <p className="text-sm font-medium">Date de naissance</p>
              <input type="date" className={INPUT_CLASS} value={birthdate} onChange={(e) => setBirthdate(e.target.value)} />
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            className="order-2 rounded-lg bg-primary-500 px-3 py-1.5 text-sm text-white transition-colors hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            onClick={onSave}
            disabled={isPending}
          >
            {isPending ? "Chargement..." : submitLabel}
          </button>
          <button
            type="button"
            className="order-1 rounded-lg border border-gray-200 px-3 py-1.5 text-sm text-gray-600 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
            onClick={onClose}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClinicianFormModal;
